import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, BookOpen, Terminal, Award, Briefcase } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  title: 'Enroll',
  desc: 'Select your track and join the academy.',
  icon: UserPlus
}, {
  title: 'Learn',
  desc: 'Interactive sessions with industry experts.',
  icon: BookOpen
}, {
  title: 'Practice',
  desc: 'Hands-on labs and real-world scenarios.',
  icon: Terminal
}, {
  title: 'Certification',
  desc: 'Intensive prep for global certifications.',
  icon: Award
}, {
  title: 'Career',
  desc: 'Placement support and mentorship.',
  icon: Briefcase
}];
export function LearningJourney() {
  return <section className="py-24 overflow-hidden" data-id="element-244">
      <div className="container mx-auto px-6" data-id="element-245">
        <SectionHeading title="Your Journey to Mastery" subtitle="A proven roadmap designed to take you from foundational knowledge to professional excellence." data-id="element-246" />

        <div className="relative mt-20" data-id="element-247">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-white/5 -translate-y-1/2 hidden lg:block" data-id="element-248" />
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 2,
          ease: 'easeInOut'
        }} className="absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-primary-blue via-accent-cyan to-status-success -translate-y-1/2 origin-left hidden lg:block" data-id="element-249" />

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-12 relative z-10" data-id="element-250">
            {steps.map((step, i) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="text-center group" data-id="element-251">
                <div className="relative mb-8 mx-auto" data-id="element-252">
                  <div className="w-20 h-20 rounded-2xl bg-background border border-white/10 flex items-center justify-center mx-auto relative z-10 group-hover:border-primary-blue/50 transition-colors duration-500" data-id="element-253">
                    <step.icon size={32} className="text-primary-blue group-hover:scale-110 transition-transform duration-500" data-id="element-254" />
                  </div>
                  {/* Pulse Effect */}
                  <div className="absolute inset-0 bg-primary-blue/20 blur-xl rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 opacity-0 group-hover:opacity-100" data-id="element-255" />

                  {/* Step Number */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary-blue text-white text-xs font-bold flex items-center justify-center border-4 border-background z-20" data-id="element-256">
                    {i + 1}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-3" data-id="element-257">
                  {step.title}
                </h3>
                <p className="text-sm text-white/50 leading-relaxed max-w-[200px] mx-auto" data-id="element-258">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}